import { Button } from '@mui/material';
import HelpTooltip from '../HelpTooltip';
import { BiHelpCircle } from 'react-icons/bi';
import { AddCircleOutline, RemoveCircleOutline } from '@mui/icons-material';

export enum LineActionType {
    ADD= 'add',
    REMOVE = 'remove',
}

export interface LineActionProps {
    action: LineActionType;
    onClick: () => void;
    actionText: string;
    helpTextTitle: string;
    helpTextBody: string;
    labelId: string;
    disabled: boolean;
}

const LineAction = (props: LineActionProps): JSX.Element => {

    const handleOnClick = (_event: React.MouseEvent<HTMLButtonElement>) => {
        props.onClick();
    };

    return (
        <Button
            disabled={props.disabled}
            id={props.labelId}
            data-testid={props.labelId}
            startIcon={
                props.action === LineActionType.ADD ? <AddCircleOutline /> : <RemoveCircleOutline />
            }
            onClick={handleOnClick}
            sx={{
                color: '#333',
                textTransform: 'none',
                backgroundColor: 'transparent',
                padding: 0,
                marginBottom: '10px',
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.05)',
                },
            }}
        >
        <span>{props.actionText} <HelpTooltip title={props.helpTextTitle} body={props.helpTextBody}> <BiHelpCircle/> </HelpTooltip></span>
      </Button>
    );
  };

export default LineAction;